import Vue from "vue";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import nextDatePicker from "vue2-datepicker";
import mixin from "../../../mixins/mixin";
import channelService from "./../../../services/channel";
import bookingService from "./../../../services/booking";
import invoiceService from "./../../../services/invoice";
import formService from "../../../services/form";
import stripeAccountsService from "../../../services/stripe_accounts";
import accountService from "../../../services/account";
import messageService from "../../../services/message";
import messageTemplateService from "../../../services/message-template";
import paymentService from "../../../services/payment";
import defaultTemplateService from "../../../services/default-template";
import automationService from "../../../services/automation";
import shortCodes from "../../../mixins/shortCodes";
import rentalService from "../../../services/rental";
import countryService from "../../../services/country";
import ColorPicker from "./../../../components/colorpicker/Colorpicker";
import eventLogger from "../../../services/event-logger";

let intervall;

export default {
  data() {
    return {
      en: en,
      fr: fr,
      interval: false,
      sortById: true,
      sortByRental: true,
      sortByGuestName: true,
      sortByCheckIn: true,
      sortByCheckOut: true,
      sortByNights: true,
      sortByPeople: true,
      sortByChannel: true,
      sortByStatus: true,
      loading: true,
      booking: {
        price: 0,
        deposit: 0,
        cleaning: 0,
        price_extra: 0,
        rental: {},
        rental_id: 0,
        checking: null,
        checkout: null,
        channel_id: 54,
        nbr_children: 0,
        nbr_adults: null,
        follow_up: 1,
        city_taxes: 0,
        service_charges: 0,
        other_charges: 0,
        payment_charges: 0,
        confirmation_code: "",
      },
      stripe_accounts: [],
      bookingEvents: {},
      guest: {},
      rental: {},
      channels: {},
      countries: [],
      rentals: [],
      signature: {},
      selectedBookingEvent: {
        checklist_group_type: {},
      },
      sendInvoice: {
        message: "",
        email: "",
        bookingId: "",
        language: "en",
      },
      sendContract: {
        message: "",
        email: "",
        language: "en",
      },
      error: null,
      success: false,
      activeTab: "informations",
      stateChecking: {
        disabled: {
          to: null,
          from: null,
        },
      },
      stateCheckout: {
        disabled: {
          to: null,
          from: null,
        },
      },
      messages: [],
      messagesLength: 0,
      message: {
        type: "mail",
      },
      invoices: {},
      invoiceSum: 0,
      contract: "",
      oldContract: "",
      payment_status: -1,
      deposit_status: -1,
      firstTime: true,
      selectedInvoiceId: "",
      payment: {},
      captured: true,
      location: window.location,
      language: localStorage.getItem("lang"),
      forms: [],
      user: {
        is_team_member: "",
        rights: {},
        right: {},
        currency: {},
      },
      reminderTime: "",
      customDateSelected: "",
      beforeOrAfterDays: 1,
      templateDetails: false,
      newTemplateOpen: false,
      messageTemplate: {},
      defaultMessageTemplate: {
        name: "",
        body: "",
        type: "",
      },
      saveTemplateDisabled: false,
      userTemplates: [],
      notifications: [],
      showTemplateType: "notification",
      paymentItem: {
        histories: [],
      },
      paymentDetails: false,
      noLocalPayments: true,
      stripe_account_id: null,
      sendPayment: {
        type: "mail",
        language: "en",
      },
      cancelPaymentId: null,
      cancelPaymentIndex: null,
      smallLoading: false,
      permalinkUrl: "",
      templates: [],
      isTemplateDeleting: false,
      isTemplateEditing: false,
      airbnbAccountToken: "",
      minutes: ["00", "30"],
      hours: [],
      checkinDate: "",
      checkoutDate: "",
      checkinDateFormated: "",
      checkoutDateFormated: "",
      form: {},
      inputs: {},
      extra_form_data: [],
      notificationData: [],
      showBookingActions: false,
      onceWatchedInUpdate: 0,
      onceWatchedInCreate: 0,
      isCheckinDateChanged: 0,
      isCheckoutDateChanged: 0,
      shortCodeName: "",
      selectedShortCode: "",
      textMessage: "",
      shortCodes: [],
      messagesLoading: false,
      clipboardBtnInvoice: "",
      clipboardBtnCopyFormLink: "",
      clipboardBtnContract: "",
      langs: ["fr", "en", "pt", "es"],
      notAvailableDates: [],
      highlightedDates: [],
      autoActionContent: {},
      notificationLoading: false,
      priceCalculationLoading: false,
      multimediaItem: {},
      bookingResDetails: "",
      cleaningFee: 0,
      cityTaxes: 0,
      bookingStatuses: {
        confirmed: 1,
        not_confirmed: 2,
        cancelled: 0,
        cancelled_by_traveler: 5,
        no_show: 3,
        request: 4,
      },
      hostPayoutFee: [],
      templateLoading: false,
      bookingUrl: null,
      paymentType: null,
      makePaymentOrDeposit: false,
      stripe: {},
      stripeToken: null,
      cardNumber: null,
      cardCvc: null,
      cardExpiry: null,
      elements: null,
      useCustomerId: false,
      currency: "",
      isPaymentCreated: true,
      shouldNotifyUserAboutCancellation: false,
      logs: [],
    };
  },

  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    Redactor: require("components/redactor/redactor.vue"),
    VLoading: require("components/loading/loading.vue"),
    VSendFormModal: require("components/send-form-modal/send-form-modal.vue"),
    NotificationContent: require("./modals/NotificationContentModal"),
    Datepicker,
    nextDatePicker,
    VShortCodeListModal: require("components/short-codes/ShortCodeListModal"),
    VResources: require("./Resources"),
    ViewCheckListMultimedia: require("./modals/ViewCheckListMultimedia"),
    ChecklistVideo: require("./ChecklistVideo"),
    ColorPicker,
  },

  mixins: [mixin, shortCodes],

  async mounted() {
    const vm = this;
    vm.loading = true;
    $(".panel-overlay").click(() => {
      vm.closeTemplates();
    });

    Vue.filter("formatDate", (date) => {
      if (!date) {
        return "N/A";
      }
      return moment(date, "YYYY-MM-DD").format("dd DD MMMM YYYY");
    });

    Vue.filter("formatShortDate", (date) => {
      if (!date) {
        return "N/A";
      }
      return moment(date, "YYYY-MM-DD")
        .lang(localStorage.getItem("lang"))
        .format("dd DD MMM");
    });

    Vue.filter("messageDate", (date) => {
      if (!date) {
        return "N/A";
      }
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(
        "ddd, D MMMM YYYY, h A"
      );
    });

    Vue.filter("trim", (text) => {
      if (!text) {
        return "N/A";
      }
      const te = text.trim();
      return te;
    });

    Vue.filter("getWeekDayFromDateCalendar", (date) => {
      moment.locale("fr", {
        months: vm.$t("months"),
        weekdaysShort: vm.$t("medWeekDays"),
        monthsShort: vm.$t("shortMonths"),
      });
      return moment(date).format("ddd DD MMMM YYYY HH:mm:ss");
    });

    Vue.filter("getShortWeekDay", (date) => {
      moment.locale("fr", {
        months: vm.$t("months"),
        weekdaysShort: vm.$t("medWeekDays"),
        monthsShort: vm.$t("shortMonths"),
      });
      return moment(date).format("dd DD MMMM YYYY");
    });

    await countryService.get(this);
    await vm.getChannels();
    await vm.getAccountRights();
    vm.getStripeAccounts();
    this.getCurrency();
    if (vm.$route.params.id) {
      await vm.getBookingById(vm.$route.params.id);
      this.bookingUrl = this.getBookingUrl(this.booking, this.booking.rental);

      if (vm.user && vm.user.rights) {
        const rights = Object.values(vm.user.rights);
        const rightExists = rights.find(
          (item) => item.parent_id === vm.booking.rental.user_id
        );
        vm.showBookingActions = rightExists && rightExists.booking_actions;
      }

      await vm.getNotAvailableDates(vm.booking.rental_id);
      vm.deposit_status = vm.getBookingDepositStatus(
        vm.booking.status,
        vm.booking.statusCode,
        vm.booking.deposit_is_done
      );
      vm.booking.status = vm.getBookingStatus(
        vm.booking.status,
        vm.booking.statusCode,
        vm.booking.payment_is_done
      );

      await vm.get_messages(vm.$route.params.id);
      await vm.get_booking_events(vm.$route.params.id);
      vm.calculate_invoice_sum();
      await vm.getAllForms(vm.booking.rental_id);
      await vm.fillNotesForm();
      vm.loading = false;
      await automationService.getCustomShortCodes(vm);
      if (vm.$route.params.tab) {
        vm.change_tab(vm.$route.params.tab);
      }
    } else {
      if (
        vm.$route.params.checking &&
        vm.$route.params.checkout &&
        vm.$route.params.rental
      ) {
        vm.booking.rental_id = vm.$route.params.rental;
        vm.booking.checking = vm.$route.params.checking;
        vm.booking.checkout = vm.$route.params.checkout;
      }
      vm.loading = false;
    }

    this.setTaxes();
    if (vm.langs.indexOf(vm.language) === -1) {
      vm.language = "en";
    }

    await vm.getTemplates();
    vm.addClipboard(".btn8", "clipboardBtnInvoice");
    vm.addClipboard(".btn9", "clipboardBtnContract");
    vm.copyFormLinkToClipboard();
    vm.buildArrivalDepartureTimeValues();
    await defaultTemplateService.get(vm);
    const container = this.$refs.messages;
    container.scrollTop = container.scrollHeight;

    $("i[data-toggle='popover']").on("click", (e) => {
      $(e.target).popover("toggle");
    });

    $(
      ".rental-detail-popover, #rental-detail, .site-menubar-body, .site-navbar, .page-content"
    ).on("click", (e) => {
      if ($(e.target).data("toggle") !== "popover") {
        $('[data-toggle="popover"]').popover("hide");
      }
    });
  },

  watch: {
    checkinDate(newCheckinDate, oldCheckinDate) {
      this.isCheckinDateChanged += 1;
      const dates = { ...this.notAvailableDates };
      const highlightedDates = this.getDatesNotAvailable(dates, "checkout");
      const newDate = new Date(this.checkinDate);
      if (this.$router.currentRoute.path === "/bookings-create") {
        if (this.stateCheckout.disabled.to == null) {
          this.onceWatchedInCreate = 1;
        }
        this.stateCheckout = {
          disabled: {
            to: new Date(
              newDate.setDate(newDate.getDate() + this.onceWatchedInCreate)
            ),
            from: null,
          },
          highlighted: {
            dates: highlightedDates,
          },
        };
        this.onceWatchedInCreate = 1;
        if (newCheckinDate && this.checkoutDate) {
          this.calculateBookingPrice(
            this.checkinDate,
            this.checkoutDate,
            this.booking.nbr_adults,
            this.booking.nbr_children
          );
        }
      } else {
        if (oldCheckinDate && newCheckinDate && this.checkoutDate) {
          this.calculateBookingPrice(
            this.checkinDate,
            this.checkoutDate,
            this.booking.nbr_adults,
            this.booking.nbr_children
          );
        }
        this.stateCheckout = {
          disabled: {
            to: new Date(
              newDate.setDate(newDate.getDate() + this.onceWatchedInUpdate)
            ),
            from: null,
          },
          highlighted: {
            dates: highlightedDates,
          },
        };
        this.onceWatchedInUpdate = 1;
      }
      if (oldCheckinDate === "" && this.checkoutDate === "") {
        const checkinNewDate = new Date(this.checkinDate);
        this.checkoutDate = new Date(
          checkinNewDate.setDate(checkinNewDate.getDate() + 1)
        );
      }
      const options = {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      const checkinDate = new Date(this.checkinDate).toLocaleDateString(
        this.language,
        options
      );
      this.checkinDateFormated =
        checkinDate.charAt(0).toUpperCase() + checkinDate.slice(1);
      if (this.checkinDateFormated.indexOf("."))
        this.checkinDateFormated =
          this.checkinDateFormated.split(".")[0] +
          this.checkinDateFormated.split(".")[1];
    },

    checkoutDate(newCheckoutDate, oldCheckoutDate) {
      const vm = this;
      vm.isCheckoutDateChanged += 1;
      const newDate = new Date(vm.checkoutDate);
      const dates = { ...this.notAvailableDates };
      this.stateChecking = {
        disabled: {
          to: null,
          from: new Date(newDate.setDate(newDate.getDate() - 1)),
        },
        highlighted: {
          dates: this.getDatesNotAvailable(dates, "checking"),
        },
      };
      if (this.$router.currentRoute.path === "/bookings-create") {
        if (newCheckoutDate && vm.checkinDate) {
          vm.calculateBookingPrice(
            vm.checkinDate,
            vm.checkoutDate,
            vm.booking.nbr_adults,
            vm.booking.nbr_children
          );
        }
      } else if (oldCheckoutDate && newCheckoutDate && vm.checkinDate) {
        vm.calculateBookingPrice(
          vm.checkinDate,
          vm.checkoutDate,
          vm.booking.nbr_adults,
          vm.booking.nbr_children
        );
      }
      const options = {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      const checkoutDate = new Date(this.checkoutDate).toLocaleDateString(
        this.language,
        options
      );
      this.checkoutDateFormated =
        checkoutDate.charAt(0).toUpperCase() + checkoutDate.slice(1);
      if (this.checkoutDateFormated.indexOf("."))
        this.checkoutDateFormated =
          this.checkoutDateFormated.split(".")[0] +
          this.checkoutDateFormated.split(".")[1];
    },

    "booking.rental_id": function (newRentalId, oldRentalId) {
      if (this.$route.params.rental) {
        this.booking.rental_id = this.$route.params.rental;
      }
      this.getCurrency();
    },

    "booking.status": function (newStatus, oldStatus) {
      if (newStatus === 0 && this.booking.channel_id != 54) {
        this.shouldNotifyUserAboutCancellation = true;
      }
    },

    messages(messages) {
      if (this.messagesLength !== messages.length) {
        this.messagesLength = messages.length;
        const container = this.$refs.messages;
        container.scrollTop = container.scrollHeight;
      }
      messages.map((message) => {
        message.text = this.createTextLinks(message.text);
      });
      this.messages = messages;
    },

    "message.type": function (newVal, oldVal) {
      switch (newVal) {
        case "sms":
          mixpanel.track("web.booking.detail.sms");
          break;
        case "whatsApp":
          mixpanel.track("web.booking.detail.whatsapp");
          break;
      }
    },

    invoices: {
      handler(invoices) {
        const vm = this;
        vm.invoices = invoices;
        vm.calculate_invoice_sum();
      },
      deep: true,
    },

    "$route.params.tab": function (newTab) {
      if (newTab) {
        this.change_tab(newTab);
      } else {
        this.change_tab("informations");
      }
    },

    "$route.params.id": async function (newId, oldId) {
      if (newId) {
        this.$router.go(this.$router.currentRoute);
      }
    },

    "payment.booking_id": function (newVal, oldVal) {
      if (newVal) {
        stripeAccountsService.getBookingById(newVal, this);
      }
    },

    "account.lang": function () {
      this.language = localStorage.getItem("lang") || "fr";
    },

    beforeOrAfterDays: {
      handler(val) {
        const vm = this;
        const now = vm.calculateTimeFromNow(vm.reminderTime);
        vm.message.text = `//remind ${now} `;
        vm.$refs["message-textarea"].focus();
      },
    },

    cleaningFee(cleaning) {
      this.booking.cleaning = cleaning;
      if (cleaning >= 0) {
        this.getPriceAmount(this.booking);
      }
    },

    cityTaxes(taxes) {
      this.booking.city_taxes = taxes;
      if (taxes >= 0) {
        this.getPriceAmount(this.booking);
      }
    },
  },

  methods: {
    updateCurrentColor(val) {
      this.booking.booking_color = val;
    },

    addClipboard(className, btn) {
      if (this.clipboardBtnCopyFormLink) {
        this.clipboardBtnCopyFormLink.destroy();
      }

      this[btn] = new Clipboard(className);

      this[btn].on("success", (e) => {
        e.clearSelection();
        toastr.success(this.$t("booking.detail.action.copied"));
      });

      this[btn].on("error", (e) => {
        e.clearSelection();
        toastr.success(this.$t("booking.detail.action.not_copied"));
      });
    },

    copyFormLinkToClipboard() {
      const vm = this;

      if (this.clipboardBtnCopyFormLink) {
        this.clipboardBtnCopyFormLink.destroy();
      }

      this.clipboardBtnCopyFormLink = new Clipboard(".btn10");
      this.clipboardBtnCopyFormLink.on("success", (e) => {
        toastr.success(vm.$t("booking.detail.action.copied"));
        e.clearSelection();
      });

      this.clipboardBtnCopyFormLink.on("error", (e) => {
        toastr.error(vm.$t("booking.detail.action.not_copied"));
      });
    },

    goBack() {
      window.history.back();
    },

    unreadLength(date) {
      let count = 0;
      if (!date) {
        return "N/A";
      }
      for (let i = 0; i < date.length; i++) {
        const message = date[i];
        if (message.unread) {
          count++;
        }
      }

      return count;
    },

    new_booking() {
      const vm = this;
      vm.booking = {};
      vm.guest = {};
      Vue.router.push({
        name: "bookings.create",
      });
    },

    async getBookingById(id) {
      const vm = this;
      await bookingService.getById(id, vm);
      this.checkUserTimeZone(vm, vm.booking.checking, vm.booking.checkout);
    },

    async getChannels() {
      const vm = this;
      await channelService.get(vm);
    },

    save_booking(booking, guest) {
      this.loading = true;
      const img = this.signature;

      const formData = new FormData();
      formData.append("image", img);
      formData.append("folder", "signatures");
      if (this.deposit_status == 14) {
        booking.statusCode = 14;
        booking.deposit_is_done = 0;
      } else if (this.deposit_status == 15) {
        booking.statusCode = 15;
        booking.deposit_is_done = 1;
      }

      if (
        this.payment_status == 12 &&
        parseInt(booking.status) !== 0 &&
        parseInt(booking.status) !== 3
      ) {
        booking.statusCode = 12;
        booking.payment_is_done = 1;
        booking.status = 1;
      } else if (this.payment_status == 10) {
        booking.statusCode = 10;
        booking.payment_is_done = 0;
      }

      booking.cleaning = this.cleaningFee;
      booking.city_taxes = this.cityTaxes;

      if (img.name) {
        // TODO Use Service for files request
        Vue.$http
          .post("/files", formData)
          .then((response) => {
            if (response && response.status === 200) {
              booking.signature = response.data.image;
              this.store_booking(booking, guest);
            }
          })
          .catch((error) => {
            if (error.response) {
              toastr.error(error.response.data.msg.image[0]);
            }
          });
      } else {
        booking.signature = null;
        this.store_booking(booking, guest);
      }
    },

    store_booking(booking, guest, confirmed = false) {
      const data = Object.assign(booking, guest);
      data.checking = moment(this.checkinDate, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      data.checkout = moment(this.checkoutDate, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      data.cleaning = this.cleaningFee;
      data.city_taxes = this.cityTaxes;
      if (data.phone) {
        data.phone = data.phone.replace(/\s/g, "");
      }
      data.confirmed = confirmed;
      bookingService.store(this, data);
    },

    pre_edit_booking(booking, guest, inputs = null) {
      if (this.shouldNotifyUserAboutCancellation) {
        swal(
          {
            title: "Attention",
            text: this.$t("swal_popup.cancel_platform"),
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-red",
            confirmButtonText: this.$t("swal_popup.confirm"),
            cancelButtonText: this.$t("swal_popup.cancel"),
            closeOnConfirm: true,
            html: true,
          },
          () => {
            this.edit_booking(booking, guest, inputs);
          }
        );
      } else {
        this.edit_booking(booking, guest, inputs);
      }
    },
    edit_booking(booking, guest, inputs = null) {
      const vm = this;
      const id = booking.id;
      if (vm.deposit_status == 14) {
        booking.statusCode = 14;
        booking.deposit_is_done = 0;
      } else if (vm.deposit_status == 15) {
        booking.statusCode = 15;
        booking.deposit_is_done = 1;
      }
      if (
        vm.payment_status == 12 &&
        parseInt(booking.status) !== 0 &&
        parseInt(booking.status) !== 3 &&
        parseInt(booking.status) !== 5
      ) {
        booking.statusCode = 12;
        booking.payment_is_done = 1;
        booking.status = 1;
      } else if (vm.payment_status === 12 && parseInt(booking.status) === 3) {
        booking.statusCode = 12;
        booking.payment_is_done = 1;
      } else if (vm.payment_status === 10) {
        booking.statusCode = 10;
        booking.payment_is_done = 0;
      }
      if (inputs) {
        booking.extra_data_from_form = inputs;
      }
      const data = Object.assign(booking, guest);
      data.id = id;
      const offset = new Date().getTimezoneOffset();
      if (offset > 0) {
        data.checking =
          vm.isCheckinDateChanged > 1
            ? moment(vm.checkinDate).format("YYYY-MM-DD")
            : moment(vm.checkinDate).subtract(1, "days").format("YYYY-MM-DD");
        data.checkout =
          vm.isCheckoutDateChanged > 1
            ? moment(vm.checkoutDate).format("YYYY-MM-DD")
            : moment(vm.checkoutDate).subtract(1, "days").format("YYYY-MM-DD");
      } else {
        data.checking = moment(vm.checkinDate).format("YYYY-MM-DD");
        data.checkout = moment(vm.checkoutDate).format("YYYY-MM-DD");
      }

      data.city_taxes = this.cityTaxes;
      data.cleaning = this.cleaningFee;
      if (data.phone) {
        data.phone = data.phone.replace(/\s/g, "");
      }
      if (data.codes && data.codes[0] && data.codes[0].code !== "") {
        data.door_code = data.codes[0].code;
      }

      vm.loading = true;
      // TODO Use Service for Update boooking
      Vue.$http
        .put(`/bookings/${id}`, data)
        .then((response) => {
          if (response && response.status === 200) {
            toastr.success(response.data.msg);
            vm.loading = false;
            Vue.router.push({
              name: "bookings.index",
            });
          }
        })
        .catch((error) => {
          vm.loading = false;
          vm.showToasterError(error);
        });
    },

    delete_booking(id) {
      const vm = this;
      swal(
        {
          title: "Êtes-vous sûr ?",
          text: "Cette réservation sera définitivement supprimée de SuperHote. Si elle a été effectuée via une plateforme tierce (Airbnb, Booking, etc.), elle sera automatiquement réimportée dans SuperHote. Pour la supprimer définitivement, il faut l'annuler directement sur la plateforme d'origine telle que Airbnb, Booking, etc. Vous pouvez aussi passer la réservation au statut 'No Show' afin de réouvrir le calendrier.",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: "Oui je la supprime !",
          cancelButtonText: "Annuler",
          closeOnConfirm: false,
        },
        () => {
          // TODO Use Service for Deleting Booking
          Vue.$http
            .delete(`/bookings/${id}`)
            .then((response) => {
              if (response && response.status === 200) {
                swal(
                  "Suppression réussie !",
                  "Cette réservation a bien été supprimée !",
                  "success"
                );
                Vue.router.push({
                  name: "bookings.index",
                });
              }
            })
            .catch((error) => {
              vm.showToasterError(error);
            });
        }
      );
    },

    async change_tab(tab) {
      const vm = this;
      const tabs = [
        "contract",
        "events",
        "event-logger",
        "forms",
        "informations",
        "invoices",
        "messages",
        "payments",
        "resources",
      ];
      if (tabs.includes(tab)) {
        vm.activeTab = tab;
      }

      switch (tab) {
        case "contract":
          if (vm.firstTime) {
            vm.firstTime = false;
            if (vm.booking.contract) {
              vm.oldContract = $("#redactor-uuid-0").html();
            } else if (vm.rental.contract) {
              vm.oldContract = $("#redactor-uuid-0").html();
            } else {
              vm.oldContract = $("#redactor-uuid-0").html();
            }
          }
          break;
        case "event-logger":
          await eventLogger.get(vm, vm.booking.id, vm.booking.rental_id);
          break;
        case "messages":
          if (vm.$route.params.id != undefined) {
            intervall = setInterval(() => {
              vm.get_messages(vm.$route.params.id);
            }, 30000);

            vm.mark_as_read_messages(vm.$route.params.id);
          }
          break;
      }

      // send mixpanel event
      switch (tab) {
        case "informations":
          mixpanel.track("web.booking.details.info");
          break;
        case "messages":
          mixpanel.track("web.booking.details.message");
          break;
        case "payments":
          mixpanel.track("web.booking.details.payments");
          break;
        case "contract":
          mixpanel.track("web.booking.details.contract");
          break;
        case "invoices":
          mixpanel.track("web.booking.details.invoice");
          break;
        case "events":
          mixpanel.track("web.booking.details.checklists");
          break;
        case "forms":
          mixpanel.track("web.booking.details.forms");
          break;
      }

      if (vm.$route.params.id) {
        Vue.router.push({
          name: "bookings.details.tab",
          params: { id: vm.$route.params.id, tab: vm.activeTab },
        });
      } else {
        Vue.router.push({
          name: "bookings.create.tab",
          params: { tab: vm.activeTab },
        });
      }
    },

    send_message(message) {
      const vm = this;
      message.booking_id = vm.booking.id;
      message.guest_id = vm.guest.id;
      message.from = "user";
      vm.messagesLoading = true;

      if (message.type === "sms") {
        messageService.sendSms(this, message);
      } else if (message.type === "mail" || message.type === "note") {
        // TODO Use Service for Send mail
        Vue.$http
          .post("/messages", { message, token: vm.airbnbAccountToken })
          .then((response) => {
            if (response && response.status === 200) {
              vm.success = response.data.msg;
              vm.get_messages(vm.$route.params.id);
              vm.message.text = "";
              vm.messagesLoading = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              vm.loading = false;
              vm.messagesLoading = false;
              vm.showToasterError(error);
              if (error.response.data.authErrors) {
                const authErrors = error.response.data.authErrors;
                for (const error of authErrors) {
                  toastr.error(
                    `${vm.$t(
                      "account.settings.user_platforms_section.airbnb_auth_error"
                    )} ${error}`
                  );
                }
              }
            }
          });
      } else if (message.type == "reminder") {
        message.reminder_id = vm.reminderTime;
        if (message.reminder_id == 6) {
          message.reminder_custom_time = vm.customDateSelected;
        } else if (
          vm.message.reminder_id == 7 ||
          vm.message.reminder_id == 8 ||
          vm.message.reminder_id == 9 ||
          vm.message.reminder_id == 10
        ) {
          vm.message.after_or_before_days = vm.beforeOrAfterDays;
        }
        messageService.saveReminder(vm, vm.message, true);
      } else if (message.type == "whatsApp") {
        let phone = vm.guest.phone.replace(/\s+/g, "");
        phone = phone.replace(/[^\w +]/g, "");
        const text = encodeURIComponent(vm.message.text);
        window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
        vm.messagesLoading = false;
      }
    },

    async get_messages(booking_id) {
      const vm = this;
      // TODO Use Service for getting Messages
      if (booking_id != undefined) {
        return Vue.$http
          .get(`/messages-list?booking_id=${booking_id}`)
          .then((response) => {
            if (response && response.status === 200) {
              function sortBy(array) {
                let filterA, filterB;
                return array.sort((a, b) => {
                  filterA = a.created_at;
                  filterB = b.created_at;
                  return filterA > filterB ? 1 : -1;
                });
              }
              const messagesAll = sortBy(response.data.messages);
              vm.messages = messagesAll;
              vm.airbnbAccountToken = response.data.airbnbAccountToken;
              if (response.data.authErrors) {
                const authErrors = response.data.authErrors;
                for (const error of authErrors) {
                  toastr.error(
                    `${vm.$t(
                      "account.settings.user_platforms_section.airbnb_auth_error"
                    )} ${error}`
                  );
                }
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              clearInterval(intervall);
              vm.error = error.response.data.msg;
            }
          });
      }
      clearInterval(intervall);
    },

    mark_as_read_messages(bookingId) {
      messageService.markMessageAsRead(this, bookingId);
    },

    add_invoice_item() {
      const invoice = {
        description: "",
        amount: 0,
        type: "other",
      };
      this.invoices.push(invoice);
    },

    remove_invoice_item(i, invoiceId) {
      const vm = this;
      vm.selectedInvoiceId = invoiceId;
      $("#charge-modal").addClass("show");
      $("#charge-modal").css({ "z-index": 10000 });
      $(".panel-overlay").fadeIn();
    },

    calculate_invoice_sum() {
      this.invoiceSum = 0;
      if (this.invoices) {
        for (let i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].imported === 0) {
            if (this.invoices[i].captured === 1) {
              this.invoiceSum +=
                this.invoices[i].amount * this.invoices[i].quantity;
            }
          } else {
            this.invoiceSum +=
              this.invoices[i].amount * this.invoices[i].quantity;
          }
          this.invoiceSum = parseFloat(this.invoiceSum.toFixed(2));
        }
      }
    },

    save_booking_contract(booking) {
      const vm = this;
      vm.loading = true;
      const img = vm.signature;

      const formData = new FormData();
      formData.append("image", img);
      formData.append("folder", "signatures");

      if (img.name) {
        // TODO Use Service for files request
        Vue.$http
          .post("/files", formData)
          .then((response) => {
            if (response && response.status === 200) {
              booking.signature = response.data.image;
              vm.store_booking_contract(booking);
            }
          })
          .catch((error) => {
            if (error.response) {
              toastr.error(error.response.data.msg.image[0]);
            }
          });
      } else {
        booking.signature = null;
        vm.store_booking_contract(booking);
      }
    },

    store_booking_contract(booking) {
      const vm = this;
      vm.contract = $("#redactor-uuid-0").html();
      if (vm.contract == "<p>?</p>") {
        vm.showToasterError("Contract can't be empty");
        vm.loading = false;
      } else if (vm.contract.length > 0 && vm.contract != "<p>?</p>") {
        const data = {};
        data.contract = vm.contract;
        data.signature = booking.signature;
        // TODO Create Service for change booking contract
        Vue.$http
          .put(`/bookings/change-contract/${booking.id}`, data)
          .then((response) => {
            if (response && response.status === 200) {
              toastr.success(response.data.msg);
              vm.loading = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              vm.showToasterError(error);
              vm.loading = false;
            }
          });
      } else {
        vm.showToasterError("Contract can't be empty");
        vm.loading = false;
      }
    },

    preview_booking_contract(booking) {
      const vm = this;
      vm.contract = $("#redactor-uuid-0").html();

      if (vm.contract != vm.oldContract) {
        const data = {};
        data.contract = vm.contract;
        // TODO Use Service for changing booking contract
        Vue.$http
          .put(`/bookings/change-contract/${booking.id}`, data)
          .then((response) => {
            if (response.status === 200) {
              toastr.success(response.data.msg);
            }
          })
          .catch((error) => {
            if (error.response) {
              vm.showToasterError(error);
              vm.loading = false;
            }
          });
      }
    },

    save_invoices(invoices) {
      const bookingId = this.$route.params.id;
      invoiceService.save(this, bookingId, invoices);
    },

    delete_invoice(id) {
      const vm = this;
      const booking_id = vm.$route.params.id;
      // TODO Create Service for Delete Invoice
      Vue.$http
        .delete(`/invoice/${booking_id}/${id}`)
        .then((response) => {
          if (response && response.status === 200) {
            vm.close_invoice_modal();
            vm.getBookingById(vm.$route.params.id);
            toastr.success(response.data.msg);
            vm.loading = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.showToasterError(error);
            vm.loading = false;
          }
        });
    },

    close_invoice_modal() {
      $(".panel-overlay").fadeOut();
      $("#charge-modal").removeClass("show");
      $("#charge-modal").css({ "z-index": 0 });
      $("body").removeClass("modal-open");
    },

    async save_payment(payment) {
      this.smallLoading = true;
      if (!payment.booking_id) {
        payment.booking_id = null;
      }

      if (this.captured) {
        payment.captured = 1;
      } else {
        payment.captured = 0;
      }

      if (this.booking.rental_id) {
        payment.rental_id = this.booking.rental_id;
      }

      await paymentService.save(this, payment);
      if (this.payment && this.payment.id) {
        await this.getBookingById(this.$route.params.id);
        this.getBookingStatus(
          this.booking.status,
          this.booking.statusCode,
          this.booking.payment_is_done
        );
        return this.payment;
      }
    },

    showStripeAccount() {
      if (this.makePaymentOrDeposit) {
        $("#make-payment-modal-close").click(() => {
          $("#make-payment-modal").removeClass("show");
          $("body").removeClass("modal-open");
          $("div.modal-backdrop.fade.show").remove();
        });
        $("#make-payment-modal").addClass("show");
        $("body").addClass("modal-open");
        $("body").append('<div class="modal-backdrop fade show"></div>');
        $(".modal-content").css({ display: "block" });
      } else {
        $("#additional-modal-close").click(() => {
          $("#additional-payment-modal").removeClass("show");
          $("body").removeClass("modal-open");
          $("div.modal-backdrop.fade.show").remove();
        });
        $("#additional-payment-modal").addClass("show");
        $("body").addClass("modal-open");
        $("body").append('<div class="modal-backdrop fade show"></div>');
        $(".modal-content").css({ display: "block" });
      }
      this.captured = this.paymentType;
      this.payment = {
        amount: null,
        type: "nights",
        booking_id: this.booking.id,
        customer_email: this.guest.email,
        description: null,
        captured: this.captured,
        auto_renew: 0,
      };
      if (
        this.stripe_accounts &&
        this.stripe_accounts[0] &&
        this.stripe_accounts[0].id
      ) {
        if (
          this.booking.rental.stripe_account_id &&
          this.stripe_accounts.filter(
            (account) => account.id === this.booking.rental.stripe_account_id
          ).length > 0
        ) {
          this.payment.stripe_account_id =
            this.booking.rental.stripe_account_id;
        } else {
          this.payment.stripe_account_id = this.stripe_accounts[0].id;
        }
      }

      const connectedStripeAccount = this.stripe_accounts.find(
        (account) => account.id === this.payment.stripe_account_id
      );
      this.stripe = Stripe(connectedStripeAccount.stripe_public_key);
      this.useCustomerId = !!this.booking.customer_id;
      this.elements = this.stripe.elements();
      const elementStyle = {
        base: {
          color: "#878787",
          lineHeight: "25px",
          fontSize: "16px",
          "::placeholder": {
            color: "#878787",
            fontSize: "14px",
          },
        },
      };
      this.cardNumber = this.elements.create("cardNumber", {
        style: elementStyle,
        placeholder: "Card number",
      });
      this.cardNumber.mount("#charge-card-number");
      this.cardExpiry = this.elements.create("cardExpiry", {
        style: elementStyle,
        placeholder: "MM/AA",
      });
      this.cardExpiry.mount("#charge-card-expiration-data");
      this.cardCvc = this.elements.create("cardCvc", {
        style: elementStyle,
        placeholder: "CVC",
      });
      this.cardCvc.mount("#charge-card-cvc");
      this.cardCvc.on("ready", () => {
        this.smallLoading = false;
      });
    },

    async chargePayment() {
      this.payment.captured = this.captured ? 1 : 0;
      if (this.useCustomerId) {
        await paymentService.save(this, this.payment);
        if (
          this.makePaymentOrDeposit &&
          Object.keys(this.payment) &&
          this.isPaymentCreated
        ) {
          const data = {
            customer: this.booking.customer_id,
            paymentId: this.payment.id,
            stripeEmail: this.payment.customer_email,
            stripeToken: this.stripeToken,
          };
          this.paymentDisabled = true;
          paymentService.chargePaymentByMoto(this, data);
        }
      } else {
        this.stripe
          .createToken(this.cardNumber)
          .then(this.stripeResponseHandler);
      }
    },

    async stripeResponseHandler(response) {
      if (response.error) {
        const text = this.getErrorMessage(response.error);
        toastr.error(text);
      } else {
        this.stripeToken = response.token.id;
        await paymentService.save(this, this.payment);
        if (
          this.makePaymentOrDeposit &&
          Object.keys(this.payment) &&
          this.isPaymentCreated
        ) {
          const data = {
            paymentId: this.payment.id,
            stripeEmail: this.payment.customer_email,
            stripeToken: this.stripeToken,
          };
          this.paymentDisabled = true;
          paymentService.chargePaymentByMoto(this, data);
        }
      }
    },

    async makePayment(paymentType) {
      this.paymentType = paymentType;
      this.makePaymentOrDeposit = true;
      await paymentService.checkUsersPaymentAccess(this, false);
    },

    newPayment(paymentType) {
      this.paymentType = paymentType;
      this.makePaymentOrDeposit = false;
      paymentService.checkUsersPaymentAccess(this, false);
    },

    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.signature = files[0];
    },

    open_send_invoice_modal() {
      const vm = this;
      const guest = vm.booking.guest;
      // get default template detecting language
      const template = vm.getDefaultTemplate(guest, "invoice", "Send invoice");

      const price = this.getPriceAmount(this.booking);
      const link = `${window.location.protocol}//superhote.com/applink/invoice/${vm.booking.permalink}`;
      const payLink = `${window.location.protocol}//superhote.com/applink/p/${vm.paymentItem.permalink}`;
      const checking = vm.booking.checking
        .replace("-", "")
        .replace("-", "")
        .toString();
      const checkout = vm.booking.checkout
        .replace("-", "")
        .replace("-", "")
        .toString();

      vm.sendInvoice.fromUI = true;
      vm.sendInvoice.email = vm.guest.email;
      vm.sendInvoice.subject = vm.generateMessage(
        template.subject,
        checking,
        checkout,
        link,
        price,
        payLink
      );
      vm.sendInvoice.message = vm.generateMessage(
        template.context,
        checking,
        checkout,
        link,
        price,
        payLink
      );
      vm.sendInvoice.bookingId = vm.booking.id;
      vm.openModal("#send-invoice-modal");
    },

    send_invoice(sendInvoice) {
      this.smallLoading = true;
      invoiceService.sendInvoice(sendInvoice, this);
    },

    showChecklistModal(bookingEvent) {
      this.selectedBookingEvent = bookingEvent;
      this.openModal("#checklist-modal");
    },

    showImageModal(item) {
      this.openModal("#show-image-modal");
      this.multimediaItem = { ...item };
    },

    closeImageModal() {
      $("#show-image-modal").removeClass("show");
      $.each($(".modal-backdrop"), (index, value) => {
        if (index != 0) {
          $(value).remove();
        }
      });
    },

    open_send_contract_modal() {
      const vm = this;
      const guest = vm.booking.guest;
      // get default template detecting language
      const template = vm.getDefaultTemplate(
        guest,
        "contract",
        "Send contract"
      );
      const price = this.getPriceAmount(this.booking);
      const link = `${window.location.protocol}//superhote.com/applink/booking/${vm.booking.permalink}/contract`;
      const payLink = `${window.location.protocol}//superhote.com/applink/p/${vm.paymentItem.permalink}`;
      const checking = vm.booking.checking
        .replace("-", "")
        .replace("-", "")
        .toString();
      const checkout = vm.booking.checkout
        .replace("-", "")
        .replace("-", "")
        .toString();

      vm.sendContract.email = vm.guest.email;
      vm.sendContract.subject = vm.generateMessage(
        template.subject,
        checking,
        checkout,
        link,
        price,
        payLink
      );
      vm.sendContract.message = vm.generateMessage(
        template.context,
        checking,
        checkout,
        link,
        price,
        payLink
      );
      vm.sendContract.rental_name = vm.booking.rental.name;
      vm.openModal("#send-contract-modal");
    },

    send_contract(sendContract) {
      this.smallLoading = true;
      sendContract.booking_id = this.$route.params.id;
      bookingService.sendContract(sendContract, this);
    },

    get_booking_events(booking_id) {
      bookingService.getBookingEvents(this, booking_id);
    },

    async getAllForms(rental_id) {
      const vm = this;
      await formService.get(vm, rental_id);
    },

    openSetupRentalFormTab(id) {
      Vue.router.push({
        name: "rentals.detail",
        params: { tab: "forms", id },
      });
    },

    getStripeAccounts() {
      stripeAccountsService.get(this);
    },

    async getAccountRights() {
      const vm = this;
      await accountService.getAccountRights(vm);
    },

    selectReminderTime(id) {
      const vm = this;
      vm.reminderTime = id;
      vm.message.type = "reminder";
      if (id != 6) {
        const now = vm.calculateTimeFromNow(id);
        vm.message.text = `//remind ${now} `;
        vm.$refs["message-textarea"].focus();
      } else {
        vm.message.text = "//remind";
      }
    },

    calculateTimeFromNow(id) {
      const vm = this;
      let now = moment().format("MMM DD, YYYY");
      switch (id) {
        case 1: {
          now = moment().add(1, "hours").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 2: {
          now = moment().add(2, "hours").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 3: {
          now = moment().add(1, "days").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 4: {
          now = moment().add(2, "days").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 5: {
          now = moment().add(7, "days").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 7: {
          // after checking
          const checking = vm.booking.checking;
          now = moment(checking)
            .add(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
        case 8: {
          // after checkout
          const checkout = vm.booking.checkout;
          now = moment(checkout)
            .add(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
        case 9: {
          // before checking
          const checking = vm.booking.checking;
          now = moment(checking)
            .subtract(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
        case 10: {
          // before checkout
          const checkout = vm.booking.checkout;
          now = moment(checkout)
            .subtract(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
      }

      return now;
    },

    showTemplates(editing = false) {
      if (!editing) {
        this.messageTemplate = { ...this.defaultMessageTemplate };
        this.newTemplateOpen = false;
        this.showTemplateType = "notification";
        this.getBookingTemplates();
        this.templateDetails = true;
      }
      $(".panel-overlay").fadeIn();
      $(".ninja-btn,.panel").addClass("active");
      $(".panel-overlay").fadeIn();
      $(".pannel_sec_second").css({ right: "-350px" });
    },

    closeTemplates() {
      const vm = this;
      if (vm.showTemplateType !== "notification" && vm.isTemplateEditing) {
        toastr.error(vm.$t("message_templates.save_current"));
      } else {
        $(".ninja-btn, .panel").removeClass("active");
        $(".payment-right-menu .panel").css({ right: "-350px" });
        $(".panel-overlay").fadeOut();
        $(".pannel_sec_second").css({ right: "-350px" });
        vm.templateDetails = false;
        vm.isTemplateEditing = false;
        vm.addNewFeldToTemplates("change");
      }
    },

    async createTemplate() {
      const vm = this;
      vm.saveTemplateDisabled = true;
      vm.messageTemplate.type = vm.showTemplateType;
      await messageTemplateService.createTemplate(vm, vm.messageTemplate);
    },

    async getTemplates() {
      const vm = this;
      await messageTemplateService.getTemplates(vm);
    },

    addNewFeldToTemplates(type) {
      const vm = this;
      const defLength = vm.notifications.length;
      const tempLength = vm.userTemplates.length;

      if (defLength > 0) {
        for (let i = 0; i < defLength; i++) {
          if (type == "set") {
            Vue.set(vm.notifications[i], "body_open", false);
          } else {
            vm.notifications[i].body_open = false;
          }
        }
      }

      if (tempLength > 0) {
        for (let j = 0; j < tempLength; j++) {
          if (type == "set") {
            Vue.set(vm.userTemplates[j], "body_open", false);
          } else {
            vm.userTemplates[j].body_open = false;
          }
        }
      }
    },

    openBody(index, type, event) {
      if (event.target.tagName == "BUTTON") {
        return;
      }

      switch (type) {
        case "notification":
          const defaultBefore = this.notifications[index].body_open;
          !defaultBefore && this.addNewFeldToTemplates("change");
          this.notifications[index].body_open = !defaultBefore;
          break;
        case "user": {
          const userBefore = this.userTemplates[index].body_open;
          !userBefore && this.addNewFeldToTemplates("change");
          this.userTemplates[index].body_open = !userBefore;
          break;
        }
      }
      this.$forceUpdate();
    },

    async insertBody(index, type, id) {
      let text = "";
      if (type === "notification") {
        text = this.notifications[index].message
          .replace(/<br ?\/?>/gim, "\n")
          .replace(/<\/p>/gim, "\n")
          .replace(/(<([^>]+)>)/gim, "")
          .replace(/&nbsp;/g, " ");
      } else {
        text = this.userTemplates[index].body;
      }
      const content = {
        id,
        text,
      };

      await messageService.getReplacedShortCodesText(this, content);
      const { text: objText = "" } = this.message;
      this.message.text = objText + this.textMessage;
      this.$refs["message-textarea"].focus();
      this.closeTemplates();
    },

    editTemplate(id, index, type, event) {
      const vm = this;
      if (vm.isTemplateEditing) {
        toastr.error(vm.$t("message_templates.save_current"));
        event.stopPropagation();
        return false;
      }

      vm.messageTemplate = vm.userTemplates[index];
      vm.userTemplates.splice(index, 1);
      vm.isTemplateEditing = true;
      vm.newTemplateOpen = true;
      event.stopPropagation();
    },

    deleteTemplate(id, index, type, event) {
      const vm = this;
      vm.isTemplateDeleting = true;
      messageTemplateService.deleteTemplate(vm, index, type, id);
      event.stopPropagation();
    },

    async updateTemplate() {
      const vm = this;
      vm.saveTemplateDisabled = true;
      await messageTemplateService.editTemplate(vm, vm.messageTemplate);
      vm.isTemplateEditing = false;
    },

    openPaymentPanel(payment) {
      const vm = this;
      if (payment.stripe_account_id) {
        vm.paymentItem = payment;
        vm.cancelPaymentIndex = this.hostPayoutFee.indexOf(payment);
        vm.paymentDetails = true;
        vm.permalinkUrl = `${window.location.protocol}//superhote.com/applink/p/${payment.permalink}`;
        $(".panel-overlay").fadeIn();
        $(".payment-right-menu .panel").addClass("active");
        $(".payment-right-menu .panel").css({ right: "0" });
        $(".panel-overlay").fadeIn();
        $(".pannel_sec_second").css({ right: "-350px" });
      } else {
        return false;
      }
    },

    closePaymentDetail() {
      const vm = this;
      $(".payment-right-menu .panel").removeClass("active");
      $(".panel-overlay").fadeOut();
      $(".pannel_sec_second").css({ right: "-350px" });
      vm.paymentDetails = false;
    },

    openSendPaymentModal(payment) {
      const vm = this;
      vm.closePaymentDetail();
      const guest = vm.booking.guest;
      // get default template detecting language
      let template = "";
      if (payment.captured) {
        template = vm.getDefaultTemplate(guest, "payment", "Send payment");
      } else {
        template = vm.getDefaultTemplate(guest, "deposit", "Send deposit");
      }
      const link = `${window.location.protocol}//superhote.com/applink/p/${payment.permalink}`;
      const price = this.getPriceAmount(this.booking);
      const checking = vm.booking.checking
        .replace("-", "")
        .replace("-", "")
        .toString();
      const checkout = vm.booking.checkout
        .replace("-", "")
        .replace("-", "")
        .toString();

      vm.sendPayment.email = payment.customer_email;
      payment.title = payment.title ? `${payment.title}` : "";
      payment.description = payment.description ? payment.description : "";
      vm.sendPayment.subject = vm.generateMessage(
        template.subject,
        checking,
        checkout,
        link,
        price
      );
      vm.sendPayment.message = vm.generateMessage(
        template.context,
        checking,
        checkout,
        link,
        price
      );
      vm.sendPayment.rental_id = payment.rental_id;
      vm.sendPayment.id = payment.id;
      this.$forceUpdate();
      vm.openModal("#send-payment-modal");
    },

    openCancelPaymentModal(paymentId) {
      const vm = this;
      vm.closePaymentDetail();
      vm.cancelPaymentId = paymentId;
      vm.openModal("#cancel-payment-modal");
    },

    redirectToPaymentDetails(id) {
      const vm = this;
      vm.closePaymentDetail();
      Vue.router.push({
        name: "payments.detail",
        params: { id },
      });
    },

    cancelPayment(paymentId) {
      const vm = this;
      vm.smallLoading = true;
      paymentService.cancelPayment(this, paymentId, vm.cancelPaymentIndex);
    },

    sendPaymentEmailOrSms(sendPayment) {
      this.smallLoading = true;
      if (this.sendPayment.type === "mail") {
        paymentService.sendPayment(sendPayment, this);
      } else {
        paymentService.sendPaymentBySms(sendPayment, this);
      }
    },

    paymentHistoryFilter(date) {
      if (!date) {
        return "N/A";
      }
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });
      return moment(date, "YYYY-MM-DD hh:mm:ss").format(
        "DD MMMM YYYY hh:mm:ss"
      );
    },

    getPaymentStatus(imported, status) {
      const vm = this;
      if (imported) {
        if (vm.booking.status != 0 && vm.booking.payment_is_done == 1) {
          return vm.$t("payments.index.payment_status.paid");
        }
        return vm.$t("payments.index.payment_status.pending");
      }
      if (status) {
        return vm.$t("payments.index.payment_status.paid");
      }
      return vm.$t("payments.index.payment_status.pending");
    },

    getBookingStatus(status, statusCode, paymentIsDone) {
      const vm = this;
      if (status == 1 && paymentIsDone == 1) {
        vm.payment_status = 12;
        return 1;
      } else if (status == 1 && paymentIsDone != 1) {
        vm.payment_status = 10;
        return 2;
      } else if (status == 3 && paymentIsDone != 1) {
        vm.payment_status = 10;
        return 3;
      } else if (status == 3 && paymentIsDone == 1) {
        vm.payment_status = 12;
        return 3;
      }

      switch (true) {
        case status == 1 && statusCode == 12:
          vm.payment_status = 12;
          return 1;
        case status == 3 && statusCode == 15:
          vm.payment_status = 12;
          return 3;
        case status == 3 && statusCode == 14:
          vm.payment_status = 12;
          return 3;
        case status === 0 || status === 5:
        case status === 3:
        case status === 4:
          vm.payment_status = 10;
          return status;
        default:
          vm.payment_status = 10;
          return 2;
      }
    },

    getDefaultTemplate(guest, type, name) {
      const vm = this;
      if (guest) {
        let guestCountry = null;
        if (guest.country) {
          guestCountry = guest.country.toLowerCase();
        }
        if (
          guestCountry &&
          (guestCountry === "fr" ||
            guestCountry === "en" ||
            guestCountry === "es" ||
            guestCountry === "pt")
        ) {
          if (type === "payment" || type === "deposit") {
            vm.sendPayment.language = guestCountry;
          } else if (type === "contract") {
            vm.sendContract.language = guestCountry;
          } else if (type === "invoice") {
            vm.sendInvoice.language = guestCountry;
          }
        }
      }
      const template = vm.templates.filter((t) => {
        if (
          vm.sendPayment.language &&
          (type === "payment" || type === "deposit")
        ) {
          return t.name === name && t.lang === vm.sendPayment.language;
        } else if (vm.sendContract.language && type === "contract") {
          return t.name === name && t.lang === vm.sendContract.language;
        } else if (vm.sendInvoice.language && type === "invoice") {
          return t.name === name && t.lang === vm.sendInvoice.language;
        }
      })[0];

      return template;
    },

    getPaymentHistoryActionName(actionName) {
      let name;
      if (localStorage.getItem("lang") == "fr") {
        switch (actionName) {
          case "created":
            name = "CRÊÊ";
            break;
          case "view":
            name = "VU";
            break;
          case "success":
            name = "SUCCÊS";
            break;
        }
      } else {
        name = actionName.toUpperCase();
      }
      return name;
    },

    generateMessage(
      message,
      checking,
      checkout,
      link,
      price,
      payLink = null,
      payment = null
    ) {
      const vm = this;
      const content = message
        .replace(
          /\[PAYMENT:TITLE]+/g,
          payment
            ? payment.title
            : vm.paymentItem.title
            ? vm.paymentItem.title
            : "-"
        )
        .replace(
          /\[PAYMENT:DESCRIPTION]+/g,
          payment
            ? payment.description
            : vm.paymentItem.description
            ? vm.paymentItem.description
            : "-"
        )
        .replace(/\[PAYMENT:LINK]+/g, link)
        .replace(
          /\[DEPOSITLINK]+/g,
          !vm.paymentItem.captured && !vm.paymentItem.imported ? link : "-"
        )
        .replace(
          /\[PAYLINK]+/g,
          vm.paymentItem.captured || vm.paymentItem.imported ? link : "-"
        )
        .replace(/\[BOOKING:ID]+/g, vm.booking.id)
        .replace(/\[BOOKING:RES-ID]+/g, vm.booking.booking_com_res_id)
        .replace(/\[BOOKING:CONFIRMATION-CODE]+/g, vm.booking.confirmation_code)
        .replace(/\[RENTAL:NAME]+/g, vm.booking.rental.name)
        .replace(
          /\[RENTAL:HOSTFIRSTNAME]+/g,
          vm.booking.rental.owner_first_name
        )
        .replace(/\[RENTAL:HOSTLASTNAME]+/g, vm.booking.rental.owner_last_name)
        .replace(
          /\[RENTAL:HOSTFIRSTNAME]+/g,
          vm.booking.rental.owner_first_name
        )
        .replace(/\[RENTAL:HOSTLASTNAME]+/g, vm.booking.rental.owner_last_name)
        .replace(
          /\[BOOKING:CHECKING]+/g,
          moment(vm.booking.checking, "YYYY-MM-DD").format("DD/MM/YYYY")
        )
        .replace(
          /\[BOOKING:CHECKOUT]+/g,
          moment(vm.booking.checkout, "YYYY-MM-DD").format("DD/MM/YYYY")
        )
        .replace(
          /\[BOOKING:PLATFORM]+/g,
          vm.booking.channel && vm.booking.channel.name
            ? vm.booking.channel.name
            : "Direct"
        )
        .replace(
          /\[BOOKING:CLEANINGVIDEO]+/g,
          vm.booking ? vm.getBookingCleaningVideoLink(this.bookingEvents) : ""
        )
        .replace(
          /\[CHECKING:DD-MM-YYYY]+/g,
          moment(vm.booking.checking, "YYYY-MM-DD").format("DD-MM-YYYY")
        )
        .replace(
          /\[CHECKOUT:DD-MM-YYYY]+/g,
          moment(vm.booking.checkout, "YYYY-MM-DD").format("DD-MM-YYYY")
        )
        .replace(/\[BOOKING:ADULTS]+/g, vm.booking.nbr_adults)
        .replace(/\[BOOKING:PRICE]+/g, price)
        .replace(/\[PRICE]+/g, price)
        .replace(
          /\[WELCOME_FORM_URL]+/g,
          `${window.location.protocol}//superhote.com/applink/booking/${vm.booking.permalink}/welcome`
        )
        .replace(
          /\[CHECKIN_FORM_URL]+/g,
          `${window.location.protocol}//superhote.com/applink/booking/${vm.booking.permalink}/checkin`
        )
        .replace(/\[RENTAL:EMAIL]+/g, vm.rental.email ? vm.rental.email : "-")
        .replace(/\[RENTAL:PHONE]+/g, vm.user.phone)
        .replace(
          /\[RENTAL:ADDRESS]+/g,
          vm.rental.address ? vm.rental.address : "-"
        )
        .replace(/\[RENTAL:CITY]+/g, vm.rental.city ? vm.rental.city : "-")
        .replace(
          /\[RENTAL:COUNTRY]+/g,
          vm.rental.country ? vm.rental.country.name : "-"
        )
        .replace(
          /\[RENTAL:ARRIVAL_TIME]+/g,
          vm.rental.checkin ? vm.rental.checkin : "-"
        )
        .replace(
          /\[RENTAL:DEPARTURE_TIME]+/g,
          vm.rental.checkout ? vm.rental.checkout : "-"
        )
        .replace(
          /\[INQUIRY:ARRIVE]+/g,
          vm.booking.time_in ? vm.booking.time_in : "-"
        )
        .replace(
          /\[INQUIRY:DEPART]+/g,
          vm.booking.time_out ? vm.booking.time_in : "-"
        )
        .replace(/\[INQUIRY:COST]+/g, vm.invoiceSum ? vm.invoiceSum : "")
        .replace(/\[INQUIRY:PRICE]+/g, vm.booking.price)
        .replace(/\[INQUIRY:NIGHTS]+/g, checkout - checking)
        .replace(/\[INQUIRY:ADULTS]+/g, vm.booking.nbr_adults)
        .replace(/\[INQUIRY:CHILDREN]+/g, vm.booking.nbr_children)
        .replace(/\[INQUIRY:BOOK_DATE]+/g, vm.booking.created_at)
        .replace(
          /\[CONTRACT:LINK]+/g,
          `${window.location.protocol}//superhote.com/applink/booking/${vm.booking.permalink}/contract`
        )
        .replace(
          /\[INVOICE:LINK]+/g,
          `${window.location.protocol}//superhote.com/applink/invoice/${vm.booking.permalink}`
        )
        .replace(
          /\[GUEST:NAME]+/g,
          `${vm.guest.first_name} ${vm.guest.last_name}`
        )
        .replace(/\[GUEST:FIRST_NAME]+/g, vm.guest.first_name)
        .replace(/\[GUEST:LAST_NAME]+/g, vm.guest.last_name)
        .replace(/\[GUEST:EMAIL]+/g, vm.guest.email)
        .replace(/\[GUEST:PHONE]+/g, vm.guest.phone)
        .replace(/\[GUEST:CITY]+/g, vm.guest.city)
        .replace(/\[GUEST:COUNTRY]+/g, vm.guest.country)
        .replace(/\[GUEST:ADDRESS]+/g, vm.guest.address ? vm.guest.address : "")
        .replace(/\[PAYMENT:LINK]+/g, payLink || "-")
        .replace(
          /\[DEPOSIT:LINK]+/g,
          !vm.paymentItem.captured && !vm.paymentItem.imported ? link : "-"
        )
        .replace(
          /\[DEPOSIT:TITLE]+/g,
          !vm.paymentItem.captured &&
            !vm.paymentItem.imported &&
            vm.paymentItem.title
            ? vm.paymentItem.title
            : "-"
        )
        .replace(
          /\[DEPOSIT:DESCRIPTION]+/g,
          !vm.paymentItem.captured &&
            !vm.paymentItem.imported &&
            vm.paymentItem.description
            ? vm.paymentItem.description
            : "-"
        )
        .replace(/\[AUTOPAYMENT:AMOUNT]+/g, price || "-");
      return this.replaceCustomShortCodes(content, vm.booking.rental_id);
    },

    buildArrivalDepartureTimeValues() {
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < this.minutes.length; j++) {
          i < 10
            ? this.hours.push(`0${i}:${this.minutes[j]}`)
            : this.hours.push(`${i}:${this.minutes[j]}`);
        }
      }
    },

    fillNotesForm() {
      const vm = this;
      if (vm.form) {
        const fields = vm.form.fields;
        for (const obj in fields) {
          if (!fields.hasOwnProperty(obj)) continue;
          if (vm.extra_form_data) {
            if (vm.extra_form_data[fields[obj].model]) {
              vm.inputs[fields[obj].model] =
                vm.extra_form_data[fields[obj].model];
            } else {
              vm.inputs[fields[obj].model] = "";
            }
          }
        }
        vm.$forceUpdate();
      }
    },

    getStatus(checkin, checkout) {
      if (this.booking.status != "accepted") return "Inquiry";
      const curdate = moment(new Date(), "YYYY-MM-DD").startOf("day");
      var checkin = moment(new Date(checkin), "YYYY-MM-DD").startOf("days");
      var checkout = moment(new Date(checkin), "YYYY-MM-DD").startOf("days");
      if (curdate.diff(checkin, "days") < 0) return "Booked";
      else if (
        curdate.diff(checkin, "days") >= 0 &&
        curdate.diff(checkout, "days") <= 0
      )
        return "Checked in";
      else if (curdate.diff(checkout, "days") > 0) return "Checked out";
    },

    date(date) {
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });
      return moment(date).format("ddd DD MMM");
    },

    gotoRentalDetails() {
      const vm = this;
      Vue.router.push({
        name: "rentals.detail",
        params: {
          id: vm.booking.rental.id,
        },
      });
    },

    cancelNotification(dispatchedJobId, id) {
      const vm = this;
      Vue.delete(vm.notificationData, id);
      automationService.cancelNotification(vm, dispatchedJobId);
    },

    getWeekDayFromDateCalendar(date) {
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });
      return moment(date).format("ddd DD MMMM . YYYY");
    },

    getShortWeekDay(date) {
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });
      return moment(date).format("ddd DD MMMM YYYY");
    },

    getBookingDepositStatus(status, statusCode, deposit) {
      if (status != 0 && deposit == 1 && statusCode != 14) {
        return 15;
      }
      return 14;
    },

    openShortcodeListModal(name) {
      if (this.langs.indexOf(localStorage.getItem("lang")) === -1) {
        this.shortCodeName = "name_en";
      } else {
        this.shortCodeName = `name_${localStorage.getItem("lang")}`;
      }
      this.openModal(name);
    },

    closeAndOpenModals() {
      const vm = this;
      vm.closeModal("#shortcode-list-modal");
      vm.showTemplates(true);
    },

    insertShortcodeToText() {
      const vm = this;
      const cursorPosition = $("#message-template-content").prop(
        "selectionStart"
      );
      vm.messageTemplate.body = `${vm.messageTemplate.body.substring(
        0,
        cursorPosition
      )}${vm.selectedShortCode}${vm.messageTemplate.body.substring(
        cursorPosition
      )}`;
      vm.closeAndOpenModals();
    },

    changePaymentStatus(payment) {
      bookingService.changePaymentStatus(this, payment);
    },

    getTemplateByLang(lang, type, name) {
      const booking = this.booking;
      const template = this.templates.filter(
        (t) => t.name === name && t.lang === lang
      )[0];
      if (template) {
        const price = this.getPriceAmount(booking);
        if (type === "payment") {
          if (booking.payments) {
            const payment = booking.payments.find(
              (payment) => payment.id === this.sendPayment.id
            );
            if (payment) {
              const link = `${window.location.protocol}//superhote.com/applink/p/${payment.permalink}`;
              const checking = booking.checking
                .replace("-", "")
                .replace("-", "")
                .toString();
              const checkout = booking.checkout
                .replace("-", "")
                .replace("-", "")
                .toString();

              this.sendPayment.subject = this.generateMessage(
                template.subject,
                checking,
                checkout,
                link,
                price
              );
              this.sendPayment.message = this.generateMessage(
                template.context,
                checking,
                checkout,
                link,
                price
              );
              this.sendPayment.rental_id = payment.rental_id;
            }
          }
        } else if (type === "invoice") {
          const link = `${window.location.protocol}//superhote.com/applink/invoice/${booking.permalink}`;
          const payLink = `${window.location.protocol}//superhote.com/applink/p/${this.paymentItem.permalink}`;
          const checking = booking.checking
            .replace("-", "")
            .replace("-", "")
            .toString();
          const checkout = booking.checkout
            .replace("-", "")
            .replace("-", "")
            .toString();

          this.sendInvoice.subject = this.generateMessage(
            template.subject,
            checking,
            checkout,
            link,
            price,
            payLink
          );
          this.sendInvoice.message = this.generateMessage(
            template.context,
            checking,
            checkout,
            link,
            price,
            payLink
          );
          this.sendInvoice.bookingId = booking.id;
        } else if (type === "contract") {
          const link = `${window.location.protocol}//superhote.com/applink/bookings/${booking.permalink}/contract`;
          const payLink = `${window.location.protocol}//superhote.com/applink/p/${this.paymentItem.permalink}`;
          const checking = booking.checking
            .replace("-", "")
            .replace("-", "")
            .toString();
          const checkout = booking.checkout
            .replace("-", "")
            .replace("-", "")
            .toString();

          this.sendContract.subject = this.generateMessage(
            template.subject,
            checking,
            checkout,
            link,
            price,
            payLink
          );
          this.sendContract.message = this.generateMessage(
            template.context,
            checking,
            checkout,
            link,
            price,
            payLink
          );
          this.sendContract.rental_name = booking.rental.name;
        }
      }
    },

    async calculateBookingPrice(
      checkinDate,
      checkoutDate,
      nbrAdults,
      nbrChildren
    ) {
      nbrChildren = parseInt(nbrChildren);
      nbrAdults = parseInt(nbrAdults);
      if (
        checkinDate &&
        checkoutDate &&
        this.booking.rental_id &&
        (nbrAdults !== null || nbrChildren !== null) &&
        nbrAdults > 0
      ) {
        const selectedRental = this.rentals.find(
          (rental) => rental.id === this.booking.rental_id
        );
        const checkin = moment(checkinDate).format("YYYY-MM-DD");
        const checkout = moment(checkoutDate).format("YYYY-MM-DD");

        this.priceCalculationLoading = true;
        let data = {};
        if (selectedRental.owner_plan_id === 4) {
          data = {
            api_key: selectedRental.user.api_key,
            property_key: selectedRental.property_key,
            start_date: checkin,
            end_date: checkout,
            nbr_adults: nbrAdults,
            nbr_children: nbrChildren,
            include_taxes: false,
          };

          if (this.booking.id) {
            data.booking_id = this.booking.id;
          }
          rentalService.getRoomAvailabilities(this, data);
        } else {
          data = {
            roomId: selectedRental.roomId,
            checkin,
            checkout,
            nbrAdults,
            nbrChildren,
          };
          await rentalService.getRoomAvailabilityAndPrice(this, data);
        }
      } else {
        this.booking.price = 0;
      }
    },

    async resendNotification(id) {
      await bookingService.resendNotification(this, id);
      await bookingService.getById(this.$route.params.id, this, true);
    },

    showPopover(e, status) {
      // TODO change popover in redesign
      if (status === 0) {
        $(e.target).popover("show");
      }
    },

    hidePopover(e, status) {
      // TODO change popover in redesign
      if (status === 0) {
        $(e.target).popover("hide");
      }
    },

    async createAndSend(payment) {
      await this.save_payment(payment);
      if (this.payment && this.payment.id) {
        this.openSendPaymentModal(this.payment);
      }
    },

    async getNotAvailableDates(rentalId) {
      await bookingService.getNotAvailableDates({ rentalId }, this);
    },

    getNotAvailableDatesRange() {
      const dates = { ...this.notAvailableDates };

      this.stateChecking.highlighted = {
        dates: this.getDatesNotAvailable(dates, "checking"),
      };
      this.stateCheckout.highlighted = {
        dates: this.getDatesNotAvailable(dates, "checkout"),
      };
      this.$forceUpdate();
    },

    getNotAvailableDatesAndCalculatePrice(checkinDate, checkoutDate) {
      this.calculateBookingPrice(
        checkinDate,
        checkoutDate,
        this.booking.nbr_adults,
        this.booking.nbr_children
      );
      this.getNotAvailableDates(this.booking.rental_id);
    },

    viewAutoAction(id) {
      this.notificationLoading = true;
      bookingService.getNotificationContent(this, id);
      this.openModal("#view-auto-action-modal");
    },

    changeSelectedShortCode(newSelectedShortCode) {
      this.selectedShortCode = newSelectedShortCode;
    },

    async getResources() {
      await bookingService.getResources(this, this.$route.params.id);
    },

    duplicateBooking(booking, guest) {
      this.booking = {
        rental_id: booking.rental_id,
        time_in: booking.time_in,
        time_out: booking.time_out,
        nbr_adults: booking.nbr_adults,
        nbr_children: booking.nbr_children,
        channel_id: booking.channel_id,
        price_extra: 0,
        cleaning: 0,
        deposit: 0,
        city_taxes: 0,
      };

      this.guest = {
        first_name: guest.first_name,
        last_name: guest.last_name,
        email: guest.email,
        alternative_email: guest.alternative_email,
        airbnb_email: guest.airbnb_email,
        phone: guest.phone,
        alternative_phone: guest.alternative_phone,
        zip_code: guest.zip_code,
        address: guest.address,
        city: guest.city,
        country: guest.country,
      };
      this.checkinDate = "";
      this.checkoutDate = "";
      this.payment_status = -1;
      this.deposit_status = -1;
      this.invoiceSum = 0;
      this.form = {};
      this.cityTaxes = 0;
      Vue.router.push({
        name: "bookings.create",
      });
    },

    setTaxes(isChanged = false, newCityTaxes = 0, newCleaningTaxes = 0) {
      if (this.booking.rental_id) {
        const rental = this.rentals.find(
          (rentalItem) => rentalItem.id === this.booking.rental_id
        );
        this.cleaningFee =
          this.booking.id && !isChanged && this.booking.cleaning >= 0
            ? this.booking.cleaning
            : newCleaningTaxes;
        this.cityTaxes =
          this.booking.id && !isChanged && this.booking.city_taxes >= 0
            ? parseFloat(this.booking.city_taxes.toFixed(2))
            : newCityTaxes;
      }
    },

    createGlobalPayment() {
      paymentService.createGlobalPayment(this, this.booking.permalink);
    },

    reportInvalidCard() {
      swal(
        {
          title: this.$t("rentals.detail.modals.are_you_sure"),
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div></div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("swal_popup.report"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          bookingService.reportInvalidCard(this, this.booking.id);
        }
      );
    },

    cancelReportInvalidCard() {
      swal(
        {
          title: this.$t("rentals.detail.modals.are_you_sure"),
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div></div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("swal_popup.report"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          bookingService.cancelReportInvalidCard(this, this.booking.id);
        }
      );
    },

    regenerateDoorCode() {
      swal(
        {
          title: this.$t("rentals.detail.modals.are_you_sure"),
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div></div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t(
            "booking.detail.door_code.generate_code_confirm"
          ),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          bookingService.regenerateDoorCode(this, this.booking.id);
        }
      );
    },

    async tagMessages(type) {
      const key =
        type === "mark_read"
          ? "booking_com_mark_read"
          : "booking_com_mark_no_reply";
      const value =
        type === "mark_read"
          ? this.isConversationMarkedAsUnRead
          : this.isConversationMarkedReply;

      const data = {
        bookingId: this.booking.id,
        type,
      };
      data[`${key}`] = value;

      await messageService.tagMessages(this, data);
      await this.get_messages(this.booking.id);
    },

    showIncludeOverrideModal(msg) {
      swal(
        {
          title: this.$t("rentals.detail.modals.are_you_sure"),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${msg}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("button.save"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          this.store_booking(this.booking, this.guest, true);
        }
      );
    },

    async getBookingTemplates() {
      if (this.notifications.length === 0) {
        this.templateLoading = true;
      }
      await bookingService.getBookingTemplates(this, this.booking.id);
      this.templateLoading = false;
    },

    cancelNewTemplateAdd() {
      this.newTemplateOpen = false;
      this.messageTemplate = { ...this.defaultMessageTemplate };
    },

    getCurrency() {
      const selectedRental = this.rentals.find(
        (rental) => rental.id === this.booking.rental_id
      );
      this.currency =
        selectedRental && selectedRental.currency
          ? selectedRental.currency.symbol
          : this.user.currency.symbol;
    },
  },

  computed: {
    account() {
      return this.$store.state.account;
    },

    isConversationMarkedAsUnRead() {
      if (this.messages) {
        return (
          this.messages.filter(
            (message) =>
              !message.booking_com_mark_read && message.from === "guest"
          ).length > 0
        );
      }

      return false;
    },

    isConversationMarkedReply() {
      if (this.messages) {
        return (
          this.messages.filter((message) => !message.booking_com_mark_no_reply)
            .length > 0
        );
      }

      return false;
    },
  },

  beforeDestroy() {
    if (this.clipboardBtnCopyFormLink) {
      this.clipboardBtnCopyFormLink.destroy();
    }
    if (this.clipboardBtnContract) {
      this.clipboardBtnContract.destroy();
    }
    if (this.clipboardBtnInvoice) {
      this.clipboardBtnInvoice.destroy();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/bookings/details/details.js